import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import {
  FormikSelectInput,
  FormikTextInput,
} from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { TIPOS_FERIADO } from "consts/tipos-feriado";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHFeriadoIns } from "services/services-mia/programa-salud/feriados/RNHFeriadoIns";

/**
 * Alta de un feriado: solo nombre y tipo.
 *
 * Las fechas NO se cargan acá. Un feriado es el concepto y sus fechas son registros
 * aparte, que se administran desde Series de Feriados.
 */
export default function InsertModal({ updateList, closeModal }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const [inRequest, setInRequest] = useState(false);
  const credentials = useRecoilValue(userCredentials);
  const formikRef = useRef();

  const crearFeriado = async (values) => {
    setInRequest(true);
    const response = await RNHFeriadoIns(credentials, {
      nombre: values.nombre,
      tipo: values.tipo,
    });
    setInRequest(false);

    if (!response.ok) return;

    setSnackBarInfo({
      message: "Feriado creado correctamente",
      severity: "success",
      open: true,
    });
    formikRef.current.resetForm();
    updateList();
    closeModal();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        nombre: "",
        tipo: "",
      }}
      validationSchema={yup.object({
        nombre: yup
          .string()
          .max(LARGO.nombre, mensajeLargo(LARGO.nombre))
          .required("Debe ingresar un nombre"),
        tipo: yup.string().required("Debe elegir un tipo"),
      })}
      onSubmit={(values) => {
        crearFeriado(values);
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={8}>
              <FormikTextInput
                fullWidth={true}
                name="nombre"
                labelText="Nombre"
                inputProps={{ maxLength: LARGO.nombre }}
              />
            </Grid>
            <Grid item xs={4}>
              {/* Los dos unicos tipos salen de consts/tipos-feriado, que comparte con
                  el filtro de la vista de series. La opcion vacia va `disabled`: el
                  tipo SI es obligatorio, a diferencia de otros selects del modulo. */}
              <FormikSelectInput name="tipo" labelText="Tipo">
                <option value="" disabled>
                  Seleccione
                </option>
                {TIPOS_FERIADO.map(({ cod, label }) => (
                  <option key={cod} value={cod}>
                    {label}
                  </option>
                ))}
              </FormikSelectInput>
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Crear" }}
            onCloseModal={closeModal}
          />
          {inRequest && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
